import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { ArquivoImportacaoFinalizado } from "../domain/arquivo-importacao-finalizado.model";

export class ArquivoImportacaoFinalizadoSerializer extends DomainSerializer<ArquivoImportacaoFinalizado> { }